module.exports = __webpack_public_path__ + "static/img/weighting.7db9bd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haqcs-as-a-controller-images/weighting.svg
// module id = 144
// module chunks = 1 2